import type {User} from "@project/application/user-management/users";

import {getUserManagementUserQueryOptions} from "@project/application/user-management/users";
import {AppErrorBoundary} from "@project/layouts";
import {createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../../messages/routes.messages";

import {UserPage} from "./-page/user.page";
import {UserPending} from "./-page/user.pending";

export const Route = createFileRoute("/_app/user-management/users/$userId")({
  component: RouteComponent,
  errorComponent: AppErrorBoundary,
  pendingComponent: UserPending,
  loader: ({context: {queryClient}, params}) =>
    queryClient.ensureQueryData(getUserManagementUserQueryOptions(params.userId)),
  staticData: {
    meta: {
      getLabel: (_p: Record<string, string>, data?: unknown) =>
        (data as User | undefined)?.displayName,
      getLabelDescriptor: (p: Record<string, string>) => ({
        id: routeMessages.userById.id,
        values: {userId: p["userId"]},
      }),
    },
  },
});

function RouteComponent() {
  const {userId} = Route.useParams();

  return <UserPage userId={userId} />;
}
